import React from 'react';
interface Testimonial {
  quote: string;
  initials: string;
  name: string;
  location: string;
  role: string;
}
const topTestimonials: Testimonial[] = [{
  quote: 'Organicé todo mi año de rítmica en una tarde. Tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
  initials: 'VM',
  name: 'Valeria M.',
  location: 'Buenos Aires',
  role: 'INSTRUCTORA DE GIMNASIA RÍTMICA EN CLUB DEPORTIVO'
}, {
  quote: 'Las progresiones por aparato cambiaron todo. Mis alumnas avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar.',
  initials: 'CR',
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'PROFE DE RÍTMICA EN ACADEMIA PARTICULAR'
}, {
  quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mixto de edades.',
  initials: 'SF',
  name: 'Sofía F.',
  location: 'Córdoba',
  role: 'INSTRUCTORA DE GIMNASIA RÍTMICA GRUPAL E INDIVIDUAL'
}];
export function TopTestimonials() {
  return <section className="py-8 md:py-16 bg-white" data-id="element-342">
      <div className="container mx-auto px-4" data-id="element-343">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-344">
          {topTestimonials.map((testimonial, index) => <div key={index} className="bg-accent rounded-2xl p-5 md:p-8 shadow-sm border border-primary-light/50 relative" data-id="element-345">
              <div className="text-primary text-3xl md:text-4xl font-serif absolute top-4 md:top-6 left-4 md:left-6 opacity-20" data-id="element-346">
                "
              </div>
              <p className="text-sm md:text-base text-gray-700 italic mb-4 md:mb-6 relative z-10 pt-3 md:pt-4" data-id="element-347">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3 md:gap-4" data-id="element-348">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-secondary text-white flex items-center justify-center font-bold text-sm md:text-lg flex-shrink-0" data-id="element-349">
                  {testimonial.initials}
                </div>
                <div data-id="element-350">
                  <h4 className="font-bold text-gray-900 text-sm md:text-base" data-id="element-351">
                    {testimonial.name}{' '}
                    <span className="text-gray-500 font-normal text-xs md:text-sm ml-1" data-id="element-352">
                      {testimonial.location}
                    </span>
                  </h4>
                  <p className="text-[10px] md:text-xs text-primary font-semibold mt-0.5 md:mt-1 uppercase tracking-wider" data-id="element-353">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}